import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';

import { showDialog, hideDialog } from '../../../redux/actions/dialogs';
import Dashboard from '../../Dashboard/index';
import EmployeeDialog from '../EmployeeDialog/index';
import { removeEmployeePromise, fetchStaticRoutine, fetchEmployeesRoutine } from '../../../redux/routines';
import { toArray, toJS } from '../../../utils/helper';
import { hasPermission } from '../../../utils/authenticated';

import styles from './styles';
import { isDialogVisibleSelector } from '../../../redux/selectors';
import { EMPLOYEE_DIALOG } from '../../../redux/constants/dialogs';
import EmployeesGrid from '../EmployeesGrid';

class EmployeesView extends Component {
  componentWillMount() {
    this.setState({
      editable: hasPermission('Administrator'),
    });
  }

  handleEdit = (employee) => {
    this.props.showDialog(EMPLOYEE_DIALOG, { employee });
  };

  render() {
    const { isDialogVisible, employees, fetchEmployees, removeEmployee, showDialog } = this.props;
    const { editable } = this.state;

    return (
      <Dashboard title="Employees">
        <div style={styles.wrapper}>
          <EmployeesGrid
            data={employees}
            fetch={fetchEmployees}
            onEdit={editable ? this.handleEdit : null}
            onRemove={editable ? removeEmployee : null}
            showDialog={showDialog}
          />
        </div>

        {isDialogVisible(EMPLOYEE_DIALOG) ? <EmployeeDialog/> : null}
      </Dashboard>
    );
  }
}

EmployeesView.propTypes = {
  fetchPermissions: PropTypes.func.isRequired,
  fetchEmployees: PropTypes.func.isRequired,
  removeEmployee: PropTypes.func.isRequired,
  employees: PropTypes.object,
  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    permissions: toArray(state.getIn(['static', 'permissions']).toJS()),
    employees: toJS(state.getIn(['employees', 'employees'])),
    isDialogVisible: isDialogVisibleSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      fetchPermissions: () => fetchStaticRoutine.trigger({ type: 'permissions' }),
      fetchEmployees: fetchEmployeesRoutine.trigger,
      showDialog,
      hideDialog,
    }, dispatch),
    ...bindPromiseCreators({
      removeEmployee: removeEmployeePromise,
    }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmployeesView);



// WEBPACK FOOTER //
// ./src/components/Employees/EmployeesView/index.js